import { render } from "./BaseInnerNavigationView.vue?vue&type=template&id=b005492c&scoped=true"
import script from "./BaseInnerNavigationView.vue?vue&type=script&lang=js"
export * from "./BaseInnerNavigationView.vue?vue&type=script&lang=js"

import "./BaseInnerNavigationView.vue?vue&type=style&index=0&id=b005492c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b005492c"]])

export default __exports__